import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { premiumStoresListQueries } from '@/services/premiumStores/premiumStores.queries';
import { PremiumStores } from '@/services/premiumStores/premiumStores.types';
import { useParams } from '@tanstack/react-router';

export const usePremiumStoreDetails = (holdId?: string) => {
  const manage = useParams({ from: '/(app)/store-information/premium-stores/$manage-premium-store/' });
  const { data, isLoading } = useQuery({
    ...premiumStoresListQueries.detail('A', {
      clubId: manage['manage-premium-store'] || '',
      holdId: holdId || '',
    }),
  });
  return {
    getPremiumStoreDetails: (data?.data as PremiumStores) || undefined,
    isLoading,
  };
};
